import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import { Box, Modal } from "@mui/material";
//*files
import cssClasses from "./CancelUnit.module.css";
import Close from "../../Components/Icons/Close";
//subComponent
import Button from "../../Subcomponents/Button";
import TextField from "@mui/material/TextField";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import { useSelector } from "react-redux";
//service
import { successTost } from "../../Services/Toast";
import {
	addLeadLogs,
	cancelAllotedUnit,
	updateAllotmentPaymentStatus,
	updateCRMLastUpdatedAt,
	updateLeadAllStatus,
} from "../../Services/ChangeUnitRequest";

const useStyles = makeStyles((theme) => ({
	wrapperIcons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		justifyContent: "space-around",
		marginBottom: "2rem",
		position: "relative",
	},
	closeIcon: {
		cursor: "pointer",
		position: "absolute",
		right: "1.7rem",
		top: "1.7rem",
	},
	title: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.8rem",
		lineHeight: "2.8rem",
		color: "#101828",
		marginBottom: "0.8rem",
	},
	subTitle: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelCard: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelValue: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	wrapperButtons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		columnGap: "1.2rem",
	},
	backArrow: {
		verticalAlign: "middle",
	},
	TextFieldStyle: {
		width: "100%",
		background: "#F2F4F7 !important",
		paddingRight: "0rem !important",
		borderRadius: "10px !important",
		fontSize: "1.6rem !important",
		fontFamily: "Inter-Medium !important",
		lineHeight: "2.4rem !important",
	},
	inputStyle: {
		fontFamily: "Inter-Medium !important",
		paddingRight: "0rem !important",
		fontSize: "1.6rem !important",
		lineHeight: "2.4rem !important",
		background: "#F2F4F7  !important",
		//   border: '1px solid #D0D5DD',
		boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
		borderRadius: "10px !important",
		border: "1px solid #F2F4F7",
		"& input": {
			fontSize: "1.6rem !important",
			lineHeight: "2.4rem !important",
			color: "#101828 !important",
			padding: "1.3rem 1.4rem",
			border: "none !important",
			boxShadow: "none !important",
		},

		"& input[text]": {
			color: "#101828 !important",
		},
		"& input[input:-internal-autofill-selected]": {
			background: "#F2F4F7 !important",
		},
		"& input[value]": {
			background: "#FFFFF !important",
		},
		"& .MuiOutlinedInput-notchedOutline": {
			border: "none",
		},
		"&.Mui-focused": {
			background: "#FFFFFF !important",
			border: "1px solid #84CAFF !important",
			boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
		},
		"&.Mui-error": {
			border: "1px solid red !important",
			boxShadow: "none !important",
		},
	},

	helperText: {
		background: "#FFFFFF !important",
		fontSize: "1.4rem !important",
		margin: "0rem 0 0 0 !important",
		fontFamily: "Inter-Medium !important",
		lineHeight: "1.8rem !important",
		paddingTop: "0.5rem !important ",
	},
}));

export default function CancelUnit({ open, handleClose, returnRes, allotmentDetails }) {
	const classes = useStyles();
	let loggedInUser = {};
	loggedInUser = useSelector((state) => state.Auth.user);

	const [confirmationAlertModal, setConfirmationAlertModal] = useState(false);
	const [cancelUnitData, setCancelUnitData] = useState({
		description: "",
	});
	const [helperText, setHelperText] = useState({
		description: "",
	});
	const [cancellationPercentageMsg, setCancellationPercentageMsg] = useState(null);
	useEffect(() => {
		calculateCancellationCharges();
	}, []);
	function calculateCancellationCharges() {
		//allotmentDetails.CRM === null
		if (!allotmentDetails["100B2bRes"] && !allotmentDetails.gstB2bRes && !allotmentDetails.SdrB2bRes) {
			if (allotmentDetails?.bookingId === null) {
				if (
					(allotmentDetails?.status === "Payment Complete" || allotmentDetails.status === "Partial Payment Done") &&
					allotmentDetails?.firstPaymentDate !== null
				) {
					var diffInSeconds = Math.abs(new Date(allotmentDetails?.firstPaymentDate) - new Date().valueOf()) / 1000;
					var days = Math.floor(diffInSeconds / 60 / 60 / 24);
					if (allotmentDetails?.unitData?.farvisionStatus === "Hold" || allotmentDetails?.unitId?.farvisionStatus === "Hold") {
						setCancellationPercentageMsg("Cancellation charges may apply");
					} else {
						if (
							days < 15 ||
							(allotmentDetails?.pricingType === "preselect" && allotmentDetails?.preselectConfirmation === "confirmation pending")
						) {
							setCancellationPercentageMsg("Cancellation charges are not applicable.");
						} else if (days >= 16 && days <= 30) {
							setCancellationPercentageMsg(
								`The cancellation fee will be calculated as 1%(₹${Number(allotmentDetails?.unitCost?.bsp) / 100}) of the unit cost.`
							);
						} else if (days > 30 && days <= 60) {
							setCancellationPercentageMsg(
								`The cancellation fee will be calculated as 1.5%(₹${
									(Number(allotmentDetails?.unitCost?.bsp) * 1.5) / 100
								}) of the unit cost.`
							);
						} else if (days >= 61) {
							setCancellationPercentageMsg(
								`The cancellation fee will be calculated as 2%(₹${
									(Number(allotmentDetails?.unitCost?.bsp) * 2) / 100
								}) of the unit cost.`
							);
						}
					}
				} else {
					setCancellationPercentageMsg("Cancellation charges are not applicable.");
				}
			} else if (allotmentDetails?.bookingId) {
				setCancellationPercentageMsg("Unit cannot be cancelled. Booking is done in Farvision");
			}
		} else {
			setCancellationPercentageMsg("Unit cannot be cancelled. Contact your CRM!");
		}
	}

	function validateAllMandatoryFields() {
		var form = true;
		if (cancelUnitData.description === "") {
			form = false;
			setHelperText((pre) => {
				pre.description = "Please enter description";
				return { ...pre };
			});
		}
		return {
			flag: form,
		};
	}

	function save() {
		//get Project from alloment table
		let flag = validateAllMandatoryFields();
		if (flag.flag) {
			setConfirmationAlertModal(true);
		}
	}
	function responseValue(value) {
		if (value === "confirmed") {
			// ! this is when customer is raising request; hence this must go to sales manager for approval
			let requestPending = {
				userId: loggedInUser.userId.userId,
				roleId: loggedInUser.userId.roleId,
				parentId: loggedInUser?.userId?.parentId?.userId,
			};
			cancelAllotedUnit(
				loggedInUser.userId.userId,
				allotmentDetails.allotmentPaymentId,
				cancelUnitData.description,
				"Pending",
				allotmentDetails.unitId.unitId,
				requestPending,
				loggedInUser.leadId
			).then((resp) => {
				// updateLeadAllStatus(loggedInUser?.leadId, `Cancellation Pending`)
				let obj = {
					leadId: loggedInUser?.leadId,
					leadStatus: `Cancellation Confirmation Pending by ${loggedInUser?.userId?.name}`,
					message: `Cancellation Confirmation Pending by ${loggedInUser?.userId?.name}.Cancellation request raised by lead`,
				};
				addLeadLogs(obj)
					.then((leadLog) => {
					})
					.catch((err) => {
						console.log("leadlog", err);
					});
				updateLeadAllStatus(loggedInUser?.leadId, `Cancellation Confirmation Pending by ${loggedInUser?.userId?.name}`)
					.then((updateLeadStatus) => {
						updateAllotmentPaymentStatus(allotmentDetails.allotmentPaymentId, "Cancellation Pending").then((resp) => {
							updateCRMLastUpdatedAt(allotmentDetails.allotmentPaymentId).then((crmResp) => {
								successTost("Cancellation request raised. Contact your VJ SM for further details!");
							});
						});
					})
					.catch((err) => {
						console.log(err, "err while changing unit");
					});
				// **As this request is done by customer itself
				// sendMailAndSms(data?.leademail, "Requested to Cancel Unit").then(
				//   (resp) => {
				//     if (resp.emailRes && resp.sms) {
				//       successTost(
				//         `${data?.leadname}  has requested for Cancel unit successfully.Email and sms sent successfully`
				//       );
				//     } else if (resp.emailRes === false && resp.sms) {
				//       errorTost(
				//         `${data?.leadname}  has requested for Cancel unit successfully.Sms sent successfully,error while sending email `
				//       );
				//     } else if (resp.emailRes && resp.sms === false) {
				//       errorTost(
				//         `${data?.leadname}  has requested for Cancel unit successfully.Email sent successfully,error while sending sms `
				//       );
				//     } else {
				//       errorTost(
				//         `${data?.leadname}  has requested for Cancel unit successfully.Error while sending Email and Sms`
				//       );
				//     }
				//   }
				// );
				closeModal();
				returnRes(true);
			});

			//addQuery
		} else {
			// closeModal();
		}
	}
	function closeModal() {
		handleClose();
		setHelperText((pre) => {
			pre.projectName = "";
			pre.wingName = "";
			pre.floorNo = "";
			pre.unitNo = "";
			return { ...pre };
		});
	}
	return (
		<Modal
			open={open}
			onClose={(_, reason) => {
				if (reason !== "backdropClick") {
					closeModal();
				}
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			sx={[
				{
					".MuiBackdrop-root": {
						background: "rgba(52, 64, 84, 0.7)",
					},
				},
			]}
			disableAutoFocus={true}
		>
			<Box className={cssClasses.modalWrapper}>
				<div className={cssClasses.wrapperHeader}>
					<span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
						<Close width={"1.2rem"} height={"1.2rem"} />
					</span>
					<div>Cancel Unit</div>
				</div>
				<div className={cssClasses.wrapperContent}>
					<div className={cssClasses.wrapperBlock}>
						<div className={cssClasses.blockLabel} style={{ width: "100%", textAlign: "left" }}>
							Reason:
							<span style={{ color: "red" }}> *</span>
							<div style={{ width: "100%", marginTop: "1rem" }}>
								<TextField
									maxRows={4}
									value={cancelUnitData.description}
									onChange={(e) => {
										e.target.value = e.target.value.trimStart();
										if (e.target.value.length <= 200) {
											setCancelUnitData((pre) => {
												pre.description = e.target.value;
												return { ...pre };
											});
										}
										if (e.target.value.length === 0) {
											setHelperText((pre) => {
												pre.description = "Please enter description";
												return { ...pre };
											});
										} else {
											setHelperText((pre) => {
												pre.description = "";
												return { ...pre };
											});
										}
									}}
									placeholder={"Type..."}
									helperText={helperText.description}
									error={helperText.description !== ""}
									className={classes.TextFieldStyle}
									InputProps={{
										className: classes.inputStyle,
									}}
									inputProps={{ min: 0 }}
									FormHelperTextProps={{ className: classes.helperText }}
									multiline
								/>
							</div>
						</div>
					</div>
					{/* { allotmentDetails?.status==='Payment Complete'&&( */}
					<div className={cssClasses.wrapperBlock} style={{ width: "100%", textAlign: "left" }}>
						<div className={cssClasses.blockLabel} style={{ width: "100%", textAlign: "left", color: "red" }}>
							{cancellationPercentageMsg}
						</div>
					</div>
					{/* )
           } */}
				</div>
				<div className={cssClasses.wrapperFooter}>
					<div>
						<Button
							style={{
								color: "#344054",
								backgroundColor: "#ffffff",
								fontSize: "1.6rem",
								lineHeight: "2.4rem",
							}}
							btnName={"Cancel"}
							clicked={closeModal}
						/>
					</div>
					<div>
						<Button
							style={{
								color: "#ffffff",
								backgroundColor: "#155EEF",
								fontSize: "1.6rem",
								lineHeight: "2.4rem",
							}}
							// disable={allotmentDetails.CRM !== null || allotmentDetails.CRM.length > 0}
							disable={allotmentDetails?.["100B2bRes"] || allotmentDetails?.gstB2bRes || allotmentDetails?.SdrB2bRes}
							btnName={"Raise a request"}
							clicked={() => {
								save();
							}}
						/>
					</div>

					{confirmationAlertModal && (
						<ConfirmationAlert
							open={confirmationAlertModal}
							close={() => {
								setConfirmationAlertModal(false);
							}}
							title={`Are you sure, you want to cancel ${allotmentDetails.unitId.projectId.projectName}, ${
								allotmentDetails.unitId.wingId.displayName
									? allotmentDetails.unitId.wingId.displayName
									: allotmentDetails.unitId.wingId.wingName
							}, ${allotmentDetails.unitId.unitNo} ?`}
							subTitle={""}
							// subTitle={
							//   "A cancellation mail will be sent to the lead to confirm the request"
							// }
							buttonTitle={"Cancel"}
							returnRespButton={"Confirm"}
							confirm={responseValue}
						/>
					)}
				</div>
			</Box>
		</Modal>
	);
}
